// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from trash-filled.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function TrashFilledIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="M14 4a1 1 0 0 1 .997 1.08l-.016.116-2 10a1 1 0 0 1-.863.797L12 16H4a1 1 0 0 1-.95-.69l-.03-.114-2-10a1 1 0 0 1 .864-1.19L2 4h12Zm1-4a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2h14Z"
      />
    </svg>
  );
}
